import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import CompanyBio from './components/CompanyBio';
import Credentials from './components/Credentials';
import SocialMedia from './components/SocialMedia';
import Reviews from './components/Reviews';
import ContactInfo from './components/ContactInfo';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://lonetrs.com';

const localBusinessSchema = {
  '@context': 'https://schema.org',
  '@type': 'MovingCompany',
  name: 'LONE TRS LLC',
  alternateName: 'LONE Transportation & Relocation Services',
  url: SITE_URL,
  logo: `${SITE_URL}/vite.svg`,
  description:
    'LONE TRS LLC offers premium transportation and relocation services including residential, commercial, interstate moves, vehicle transport, and general freight. Family-owned with 16 years of experience serving Las Vegas Valley to the entire West Coast.',
  telephone: '+1-415-888-5336',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Las Vegas',
    addressRegion: 'NV',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '36.1699',
    longitude: '-115.1398',
  },
  areaServed: [
    { '@type': 'State', name: 'Nevada' },
    { '@type': 'State', name: 'California' },
    { '@type': 'State', name: 'Arizona' },
    { '@type': 'State', name: 'Oregon' },
    { '@type': 'State', name: 'Washington' },
  ],
  hasCredential: [
    { '@type': 'EducationalOccupationalCredential', name: 'DOT Number 4476843' },
    { '@type': 'EducationalOccupationalCredential', name: 'MC Number 1767623' },
    { '@type': 'EducationalOccupationalCredential', name: 'Business License NV20253377515' },
  ],
  foundingDate: '2008',
  priceRange: '$$',
  sameAs: [],
};

export default function InterfacePage() {
  return (
    <div className="min-h-screen bg-dark-900">
      <title>LONE TRS LLC | Premium Transportation &amp; Relocation Services | Las Vegas</title>
      <meta
        name="description"
        content="LONE TRS LLC — family-owned moving &amp; transportation company with 16 years of experience. Residential, commercial, interstate moves, vehicle transport &amp; freight. Serving Las Vegas Valley to the West Coast. DOT #4476843."
      />
      <meta
        name="keywords"
        content="transportation services Las Vegas, relocation company Nevada, interstate moving Las Vegas, vehicle transport West Coast, commercial freight NV, residential moving Las Vegas"
      />
      <link rel="canonical" href={SITE_URL} />
      <meta property="og:title" content="LONE TRS LLC | Premium Transportation &amp; Relocation Services" />
      <meta
        property="og:description"
        content="Family-owned transportation &amp; relocation company with 16 years of experience. Serving Las Vegas Valley to the entire West Coast."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={SITE_URL} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="LONE TRS LLC | Premium Transportation &amp; Relocation" />
      <meta
        name="twitter:description"
        content="Family-owned transportation company with 16 years of experience. Las Vegas Valley to the West Coast."
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
      <Navigation />
      <HeroSection />
      <CompanyBio />
      <Credentials />
      <SocialMedia />
      <Reviews />
      <ContactInfo />
      <Footer />
    </div>
  );
}
